import { VuiLink } from "../../ui";

type Props = {
    logoUrl?: string;
    title?: string;
    url?: string;
};

export const AppHeader = ({title, url, logoUrl}: Props) => {
  return (
    <>
      {title && (
        <h1 className="vuiAppHeader">
          <VuiLink isAnchor href={url} target="_blank" className="vuiAppHeaderLink">
            {logoUrl && (
              <img src={logoUrl} alt="" className="vuiAppHeaderImage" />
            )}
            <span className="vuiAppHeaderTitle">{title}</span>
          </VuiLink>
        </h1>
      )}
    </>
  );
};
